var app = angular.module("leonardo");

var OverviewNewController = function($scope, $rootScope, PropertyService, $timeout, $filter, $controller,
                                     FilterService, $q, $state, AccountService, AuthDataService, AccountUserService,
                                     ngDialog, ReportService, NotificationService) {
  $scope.properties = [];
  $scope.accountService = AccountService;
  $scope.current = false;
  $scope.orderGroup = null;
  $scope.tab = 'past';

  $scope.canceler = $q.defer();

  $scope.groups = [
    { id: 'group',
      name: 'Property Group'
    },
    {
      id: 'portfolio',
      name: 'Portfolio'
    }
  ];

  if (AuthDataService.authData.account && AuthDataService.authData.account.managed_to_me && AuthDataService.authData.account.managed_to_me.length > 0) {
    $scope.groups.push({id:'management_company', name:'Management Company'});
  }

  if (AccountUserService.currentAccountUser.managed_by) {
    $scope.groups.push({id:'owner', name:'Owner'});
  }

  $scope.last_updated = '';

  $scope.showManagedCompanies = function () {
    return AuthDataService.authData.account && AuthDataService.authData.account.managed_to_me &&
      (AuthDataService.authData.account.managed_to_me.length > 0);
  };

  $scope.groupIsExpanded = function (id) {
    return $scope.groupExpanded === id;
  };

  $scope.toggleGroup = function (id) {
    $scope.groupExpanded = $scope.groupExpanded == id ? null : id;
  };

  $scope.indexPortfolio = function (id) {
    var index = -1;
    angular.forEach($scope.propertiesGrouped, function (value, key) {
      if (value.id == id)
        index = key;
    });
    return index;
  };

  $scope.groupProperties = function () {
    $scope.propertiesGrouped = [];
    $scope.orderGroup = null;
    var index = null;
    angular.forEach($scope.properties, function (value) {
      var id_group = [];
      var name_group = [];
      switch ($scope.group) {
        case 'group':
          if (isEmpty(value.groups) && !_.contains(id_group, 'no_group')){
            id_group.push('no_group');
            name_group.push('No Group');
          } else {
            angular.forEach(value.groups, function(group) {
              if (isNull(group.id) && !_.contains(id_group, 'no_group')) {
                id_group.push('no_group');
                name_group.push('No Group');
              } else if (!_.contains(id_group, group.id)) {
                id_group.push(group.id);
                name_group.push(group.name);
              }
            });
          }
          break;
        case 'portfolio':
          id_group = value.portfolio;
          name_group = value.portfolio_name;
          break;
        case 'owner':
          id_group = value.account;
          name_group = value.account_name;
          break;
        case 'management_company':
          id_group = value.management_company.id ? value.management_company.id : value.account;
          name_group = value.management_company.name ? value.management_company.name : value.account_name;
          break;
      }
      if (angular.isArray(id_group)) {
        angular.forEach(id_group, function (id, key) {
          index = $scope.indexPortfolio(id);
          if (index === -1) {
            $scope.propertiesGrouped.push({id: id, name: name_group[key], properties: []});
            $scope.propertiesGrouped[$scope.propertiesGrouped.length-1].properties.push(value);
          }
          else {
            $scope.propertiesGrouped[index].properties.push(value);
          }
        });
      }
      else {
        index = $scope.indexPortfolio(id_group);
        if (index === -1) {
          $scope.propertiesGrouped.push({id: id_group, name: name_group, properties: []});
          $scope.propertiesGrouped[$scope.propertiesGrouped.length-1].properties.push(value);
        }
        else {
          $scope.propertiesGrouped[index].properties.push(value);
        }
      }
    });
  };

  $scope.goToExpired = function (portfolio, property) {
    var filters = [];
    if (property) {
      FilterService.setFilter('property_reports', property.id, true);
      filters.push('property_reports');
    }
    else {
      FilterService.removeFilter('property_reports', true);
      if(portfolio) {
        FilterService.setFilter('portfolio_reports', portfolio, true);
        filters.push('portfolio_reports');
      }
      else {
        FilterService.removeFilter('portfolio_reports', true);
      }
    }
    FilterService.setFilter('filters', filters, true);
    $rootScope.$broadcast('no_reset_filters:updated', true);
    $state.go('documents.expired');
  };

  $scope.goToSnoozed = function (portfolio, property) {
    $rootScope.$broadcast('no_reset_filters:updated', true);
    var promise = null;
    if (property) {
      promise = FilterService.setProperty(property);
    }
    else if (portfolio) {
      FilterService.setFilter('portfolio', portfolio.id, true);
      FilterService.removeFilter('property', true);
    }
    $q.when(promise).then(function (){
      $state.go('property.tasks.snoozed');
    });
  };

  $scope.goToCannot = function (portfolio, property) {
    $rootScope.$broadcast('no_reset_filters:updated', true);
    var promise = null;
    if (property) {
      promise = FilterService.setProperty(property);
    }
    else if (portfolio) {
      FilterService.setFilter('portfolio', portfolio.id, true);
      FilterService.removeFilter('property', true);
    }
    $q.when(promise).then(function (){
      $state.go('property.tasks.cannot');
    });
  };

  $scope.goToActivity = function (portfolio, property){
    var filters = [];
    FilterService.setFilter('from_date', moment().format('YYYY-MM-DD'), true);
    filters.push('from_date');
    FilterService.setFilter('to_date', moment().subtract(5, 'days').format('YYYY-MM-DD'), true);
    filters.push('to_date');
    FilterService.setFilter('mia', 1, true);
    filters.push('mia');
    if (property) {
      FilterService.setFilter('property_reports', property.id, true);
      filters.push('property_reports');
    }
    else {
      FilterService.removeFilter('property_reports', true);
      if(portfolio) {
        FilterService.setFilter('portfolio_reports', portfolio, true);
        filters.push('portfolio_reports');
      }
      else {
        FilterService.removeFilter('portfolio_reports', true);
      }
    }

    FilterService.setFilter('filters', filters, true);
    ReportService.setQuickReport({ name: "Launch Activity Report", filters: {} });
    $rootScope.$broadcast('no_reset_filters:updated', true);
    $state.go('reports.activity');
  };

  $scope.submitActive = function (template) {
    if (!template) {
      return false;
    }
  };

  $scope.overrideActive = function (template) {
    if (!template) {
      return false;
    }
    if ($scope.onboarding) {
      return false;
    }
    if ($state.current.action === 'create') {
      return false;
    }
    return (!template.editable && template.overridable);
  };

  $scope.selectTab = function(tab) {
    $scope.tab = tab ? tab : $scope.tab;
  };

  $scope.reload = function () {
    PropertyService.reloadStatistics().then(function () {
      $scope.loadPage($scope.page);
      NotificationService.notify('success', 'This process may take a while, try reloading the page in a few seconds.');
    });
  };

  $scope.getEntitiesPromise = function (options) {
    $scope.canceler.resolve();
    $scope.canceler = $q.defer();
    var filters = {
      account: FilterService.getFilter('account_reports'),
      priority: FilterService.getFilter('priority'),
      category: FilterService.getFilter('category'),
      id: FilterService.getFilter('property_reports'),
      group: FilterService.getFilter('group_reports'),
      portfolio: FilterService.getFilter('portfolio_reports'),
      managed_by: FilterService.getFilter('managed_by_reports'),
      property_status: FilterService.getFilter('property_status'),
      group_by: FilterService.getFilter('group_by'),
    };
    angular.forEach(filters, function (value, key) {
      options[key] = value;
    });
    switch ($scope.group) {
      case 'owner':
        options['ordering'] = 'account__name';
        break;
      case 'portfolio':
        options['ordering'] = 'portfolio__name';
        break;
      case 'management_company':
        options['ordering'] = 'managed_by__name';
        break;
      case 'group':
        options['ordering'] = 'groups__name';
        break;
    }
    var defer = $q.defer();
    $scope.loading = false;
    var ids = [];
    $scope.properties = [];
    if ($scope.tab === 'current') {
      PropertyService.getStatistics(options, $scope.canceler.promise).then(function (data) {
        var results = data.results ? data.results : data;
        angular.forEach(results, function (result) {
          if (!_.contains(ids, result.id)) {
            result.account_name = $filter('accountName')(result.account);
            result.portfolio_name = $filter('portfolioName')(result.portfolio);
            if (result.loading) {
              $scope.loading = true;
            }
            if (!$scope.last_updated || (result.modified > $scope.last_updated)) {
              $scope.last_updated = result.modified;
              $scope.loading = false;
            }
            $scope.properties.push(result);
          }
          ids.push(result.id);
        });
        useTimeout(defer, data);
      });
      $scope.current = false;
    }
    else {
      PropertyService.getPastDue(options, $scope.canceler.promise).then(function (data) {
        var results = data.results ? data.results : data;
        angular.forEach(results, function (result) {
          if (!_.contains(ids, result.id)) {
            result.account_name = $filter('accountName')(result.account);
            if (result.loading)
              $scope.loading = true;
            if (!$scope.last_updated || (result.modified > $scope.last_updated)) {
              $scope.last_updated = result.modified;
              $scope.loading = false;
            }
            $scope.properties.push(result);
          }
          ids.push(result.id);
        });
        useTimeout(defer, data);
      });
      $scope.current = true;
    }
    return defer.promise;
  };

  function useTimeout(defer, data) {
    $timeout(function () {
      $scope.properties_aux = angular.copy($scope.properties);
      if ($scope.group) {
        $scope.groupProperties();
      }
      $scope.loading = false;
      if ($scope.properties_aux.length === 0) {
        ngDialog.open({ template: 'views/templates/dialog/no-results.html' });
      }
      defer.resolve(data);
    }, 0);
  }

  $scope.orderGroupBy = function(order, indexGroup) {
    var orderArray = order ? order.split('__') : [];
    if (orderArray.length === 0) return;
    var orderGroup = orderArray.join('.');
    if ($scope.orderGroup !== order) {
      $scope.orderGroup = order;
      $scope.propertiesGrouped[indexGroup].properties = $filter('orderBy')($scope.propertiesGrouped[indexGroup].properties, orderGroup);
    }
    else {
      $scope.orderGroup = '-' + order;
      $scope.propertiesGrouped[indexGroup].properties = $filter('orderBy')($scope.propertiesGrouped[indexGroup].properties, orderGroup, true);
    }
  };

  angular.forEach(['group', 'tab'], function (key) {
    $scope.$watch(key, function (newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue) {
          $scope.loadPage(1);
        }
      }
    });
  });

  $controller('TableFilterController', {$scope: $scope});

  $scope.loadPage(1);

};

app.controller('OverviewNewController', ['$scope', '$rootScope', 'PropertyService', '$timeout', '$filter', '$controller',
  'FilterService', '$q', '$state', 'AccountService', 'AuthDataService', 'AccountUserService', 'ngDialog', 'ReportService',
  'NotificationService', OverviewNewController]);
